export default {
  submitText: '通过',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
      span: 8,
    },
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      disabled: true,
      span: 8,
      editDisabled: true,
      search: true,
      cell: true,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
    },
    {
      label: '车牌号',
      disabled: true,
      prop: 'carNo',
      span: 8,
    },

    {
      label: '车辆分类',
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      prop: 'carClass',
      disabled: true,
      rules: [
        {
          required: true,
          message: '请选择分类',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '车辆类型',
      span: 8,
      type: 'select',
      prop: 'carType',
      disabled: true,
      dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      /*disabled: true,*/
      rules: [
        {
          required: true,
          message: '请选择车辆类型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      span: 8,
      search: true,
      disabled: true,
      rules: [
        { pattern: /^[0-9]*[0-9][0-9]*$/, message: '手机号格式错误' },
        {
          trigger: 'blur',
          min: 11,
          max: 11,
          message: '请输入11位手机号码',
        },
      ],
    },
    {
      label: '客户姓名',
      span: 8,
      search: true,
      prop: 'customerName',
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入客户姓名',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收费套餐',
      prop: 'ruleName',
      disabled: true,
      span: 8,
    },
    {
      label: '租赁起期',
      prop: 'buyStartTime',
      type: 'date',
      format: 'yyyy-MM-dd 00:00:00',
      valueFormat: 'yyyy-MM-dd hh:mm:ss',
      disabled: true,
      span: 8,
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '租赁止期',
      prop: 'buyEndTime',
      type: 'date',
      format: 'yyyy-MM-dd 23:59:59',
      valueFormat: 'yyyy-MM-dd hh:mm:ss',
      span: 8,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },


      ],
    },
    {
      label: '状态',
      prop: 'status',
      display: false,
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    {
      label: '支付方式',
      hide: true,
      prop: 'payType',
      display: false,
      span: 8,
      rules: [
        {
          // required: true,
          message: '请输入支付方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '缴费时间',
      prop: 'payTime',
      hide: true,
      display: false,
      span: 8,
      rules: [
        {
          required: true,
          message: '请输入缴费时间',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款单号',
      prop: 'payId',
      hide: true,
      span: 8,
      display: false,
      rules: [
        {
          required: true,
          message: '请输入收款单主键',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退款单号',
      span: 8,
      display: false,
      hide: true,
      prop: 'returnId',
      rules: [
        {
          required: true,
          message: '请输入退款单主键',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费标识',
      prop: 'returnFlag',
      span: 8,
      display: false,
      hide: true,
      rules: [
        {
          required: true,
          message: '请输入退费标识 0.未退费 1.已退费',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费金额',
      prop: 'returnMoney',
      span: 8,
      display: false,
      hide: true,
      rules: [
        {
          required: true,
          message: '请输入退费金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '车位编号',
      prop: 'lotNo',
      hide: true,
      span: 8,
      disabled: true,
      rules: [
        {
          required: false,
          message: '请输入停车车位编号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '房间名称',
      prop: 'areaName',
      hide: true,
      disabled: true,
      span: 16,
    },
    {
      label: '说明',
      prop: 'remark1',
      hide: true,
      span: 24,
      type: 'textarea',
      minRows: 2,
      maxlength: 100,
      showWordLimit: true,
      overHidden: true,
    },
    {
      label: '审核意见',
      prop: 'remark2',
      hide: true,
      span: 24,
      type: 'textarea',
      minRows: 2,
      maxlength: 100,
      showWordLimit: true,
      overHidden: true,
      rules: [
        {
          required: false,
          message: '请输入备注2',
          trigger: 'change',
        },
      ],
    },
    {
      label: '备注3',
      prop: 'remark3',
      hide: true,
      display: false,
      rules: [
        {
          required: true,
          message: '请输入备注3',
          trigger: 'change',
        },
      ],
    },
  ],
};
